import { log, logE } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import {
  CreateRoleFeatureRoleInput,
  EffectiveAccessControl,
  EMPTY_EFFECTIVE_ACCESS_CONTROL,
  RoleFeatureMatrix,
  UpdateRoleFeatureRoleInput,
} from "../models/role-feature.models";
import axios from "axios";

export const getCurrentUserAccess = async (): Promise<EffectiveAccessControl> => {
  const response = await api.get(`${apiUrl}/access-control/me`);
  log("REPO - getCurrentUserAccess - response", { status: response.status, source: response.data?.source });
  return response.data;
};

export const getCurrentUserAccessOrEmpty = async (): Promise<EffectiveAccessControl> => {
  try {
    return await getCurrentUserAccess();
  } catch (error) {
    const status = axios.isAxiosError(error) ? error.response?.status : undefined;
    logE(new Error("REPO - getCurrentUserAccessOrEmpty - fallback"), { status });
    return EMPTY_EFFECTIVE_ACCESS_CONTROL;
  }
};

export const getRoleFeatureMatrix = async (): Promise<RoleFeatureMatrix> => {
  const response = await api.get(`${apiUrl}/admin/access-control/role-features`);
  log("REPO - getRoleFeatureMatrix - response", { status: response.status });
  return response.data;
};

export const createRoleFeatureRole = async (input: CreateRoleFeatureRoleInput): Promise<RoleFeatureMatrix> => {
  const response = await api.post(`${apiUrl}/admin/access-control/role-features`, input);
  log("REPO - createRoleFeatureRole - response", { status: response.status });
  return response.data;
};

export const updateRoleFeatureRole = async (
  roleKey: string,
  input: UpdateRoleFeatureRoleInput,
): Promise<RoleFeatureMatrix> => {
  const response = await api.post(
    `${apiUrl}/admin/access-control/role-features/${encodeURIComponent(roleKey)}/update`,
    input,
  );
  log("REPO - updateRoleFeatureRole - response", { status: response.status });
  return response.data;
};

export const deactivateRoleFeatureRole = async (roleKey: string): Promise<RoleFeatureMatrix> => {
  const response = await api.post(
    `${apiUrl}/admin/access-control/role-features/${encodeURIComponent(roleKey)}/deactivate`,
  );
  log("REPO - deactivateRoleFeatureRole - response", { status: response.status });
  return response.data;
};

export const getAccessControlErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Access-control request failed.";
};
